import { useQuery, useQueryClient } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';
import { withCancelToken } from './helpers/withCancelToken';
import { useEvent } from '../hooks/useEvent';

const flatCommentsQuerySelectors = {
  selectReverse: (data) => {
    if (!data || data === 'Error') return data;
    return data.slice().reverse();
  },
};

const fetcher = (addressId, source) => {
  return request.get(
    `HousingStock/address/${addressId}/comment_v2`,
    undefined,
    'При загрузке комментариев произошла ошибка',
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token }
  );
};

const cancelableFetcher = (addressId) => {
  return withCancelToken((source) => fetcher(addressId, source));
};

const useFlatComments = (addressId, options = {}) =>
  useQuery(
    queryKeys.flatComments(addressId),
    () => cancelableFetcher(addressId),
    {
      enabled: Boolean(addressId),
      staleTime: 1000 * 60,
      ...options,
    }
  );

const useInvalidateFlatComments = () => {
  const queryClient = useQueryClient();

  return useEvent((addressId) =>
    queryClient.invalidateQueries(queryKeys.flatComments(addressId))
  );
};

export { useInvalidateFlatComments, flatCommentsQuerySelectors };

export default useFlatComments;
